import { RoundedCheckBox, ListItemChecked } from "../icons";
import LoadingGif from '../../images/loading_image.gif';
import { Dropdown, ButtonGroup, Button } from "react-bootstrap";
import { useState, useCallback, useContext } from "react";
import { RecycleBinContext } from "../../contexts/RecycleBinContext";
import { formatDay } from "../../utils";
import { dateTimeConstants } from "../../constants";
import { ContentGroupPopupContext } from "../../contexts/ContentGroupPopupContext";
import { useDispatch } from "react-redux";
import { alertActions, recycleBinActions } from "../../actions";
import { DismissablePopup } from "../popup";

const ArchiveCardItem = ({
  data,
  organization_id,
  selected
}) => {
  const [selectedSetting, setSelectedSetting] = useState('restore'); // restore, delete
  const { addCardToSelection, removeCardToSelection, selectAll } = useContext(RecycleBinContext);
  const { setContentGroupPopUp } = useContext(ContentGroupPopupContext);
  const { workspace, id } = data;
  const dispatch = useDispatch();

  const [showRestoreModal, setShowRestoreModal] = useState(false);
  const handleRestore = () => {
    const callback =() => {
      setShowRestoreModal(false);
      removeCardToSelection(data);
    }

    const ids = [id];
    const all = false
    const params = {
      all: all,
      organization_id,
      ids,
      callback
    }

    dispatch(recycleBinActions.restoreDeletedContentGroups(params))
  }

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleDelete = () => {
    const callback =() => {
      setShowDeleteModal(false);
      removeCardToSelection(data);
    }

    const onError = (response) => {
      dispatch(alertActions.error(response.data.error));
      setShowDeleteModal(false);
    }

    const ids = [id];
    const all = false
    const params = {
      all: all,
      organization_id,
      ids,
      callback,
      onError
    }

    dispatch(recycleBinActions.destroyDeletedContentGroups(params))
  }

  const getSettingDisplayName = useCallback(() => {
    switch (selectedSetting) {
      case "restore":
        return 'Restore';
      case "delete":
        return 'Delete';
      default:
        return 'Invalid Setting';
    } 
  }, [selectedSetting])

  const settingFunction = useCallback(() => {
    switch (selectedSetting) {
      case "restore":
        setShowRestoreModal(true);
        return;
      case "delete":
        setShowDeleteModal(true);
        return;
      default:
        console.error('Invalid Setting');
        return;
    } 
  }, [selectedSetting]);

  return (
    <>
      <td
        className="text-right checbox_cell p-1"
      >
        {
          selected || selectAll ?
            <div
              className="cursor-pointer"
              style={{width: 20, height: 20}}
              onClick={() => removeCardToSelection(data)}
            >
              <ListItemChecked
                color={'#FF3B30'}
                height={20}
                width={20}
              />
            </div>
            
          :
            <div
              className="cursor-pointer"
              style={{width: 20, height: 20}}
              onClick={() => addCardToSelection(data)}
            >
              <RoundedCheckBox 
                color={'#D9D9D9'}
                height={20}
                width={20}
                className={'checkbox-hoverable'}
              />
            </div>
            
        }
        
      </td>
      <td
        className="card_title_cell"
      >
        <div className="card_container archived d-flex align-items-center">
          {
            data.preview && data.preview.content_attachment &&
              <div
                data-id={data.id}
                data-image-pending={data.preview && data.preview.content_attachment && data.preview.content_attachment_type != 'application/pdf' ? 'true' : 'false'}
                id={`find_div_${data.id}`}
                className="image_div"
              >
                {
                  data.preview.content_attachment_type == "application/pdf" ?
                    <i className=" fa fa-file-pdf-o" aria-hidden="true" style={{fontSize: 35}}></i>
                :
                    <img src={LoadingGif} height={50} width={50}/>
                }
              </div>            
          }

          <div className="ml-3">
            <div 
              className="card_title truncate cursor-pointer"
              onClick={() => setContentGroupPopUp({id: data.id, workspace_id: data.workspace.id, show: true})}
            >
              {data.name}
            </div>
            { data.summary && <div className="card_description truncate">{data.summary}</div> }

          </div>
        </div>
      </td>
      <td className="text-center">
        <div className="text-truncate mx-auto workpace_name">{workspace.name}</div>      
      </td>
      <td className="text-center">
        <div className="text-truncate mx-auto deleted_by">
        {data.deleted_by}
        </div>
      </td>
      <td className="text-center">{formatDay(data.deleted_at, dateTimeConstants.DISPLAY_ALT_FORMAT)}</td>
      <td className="text-center">
        <Dropdown 
          as={ButtonGroup}
          align="end"
          drop={'down'}
          variant={''}
          size={ 'sm' }
        >
          <Button 
            variant=""
            onClick={settingFunction}
          >
            {getSettingDisplayName()}
          </Button>

          <Dropdown.Toggle split variant="" id="dropdown-split-basic" />

          <Dropdown.Menu
            className={ 'sm' }
          >
            <Dropdown.Item className="text-center" onClick={() => setShowDeleteModal(true)}>Delete</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <DismissablePopup 
          show={showRestoreModal}
          message={'Put this card back in its original stage?'}
          title={'Restore'}
          onClose={() => setShowRestoreModal(false)}
          onConfirm={handleRestore}
          confirmBtnVariant={'success'}
        />

        <DismissablePopup 
          show={showDeleteModal}
          message={'Are you sure? This action cannot be undone.'}
          title={'Delete'}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={handleDelete}
        />
      </td>
    </>
  );
};

export default ArchiveCardItem;